export let hrms14xColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRMS14XC1',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRMS14XC1',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'dteinput',
      name: '',
      labelCodapp: 'HRMS14XC1',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 150px;',
      dataType: 'date'
    }, {
      key: 'numseq',
      name: '',
      labelCodapp: 'HRMS14XC1',
      labelIndex: '110',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_staappr',
      name: '',
      labelCodapp: 'HRMS14XC1',
      labelIndex: '120',
      style: 'min-width: 200px;',
      eventName: 'status'
    }, {
      key: 'routeno',
      name: '',
      labelCodapp: 'HRMS14XC1',
      labelIndex: '130',
      class: 'align-center',
      style: 'min-width: 100px;',
      eventName: 'routeno'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRMS14XC1',
      labelIndex: '140',
      style: 'min-width: 200px;'
    }, {
      key: 'dteappr',
      name: '',
      labelCodapp: 'HRMS14XC1',
      labelIndex: '150',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'remark',
      name: '',
      labelCodapp: 'HRMS14XC1',
      labelIndex: '160',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRMS14XC1',
      labelIndex: '165',
      style: 'min-width: 200px;'
    }
  ]
  let popupStatusTableColumns = [
    {
      key: 'typeapp',
      name: '',
      labelCodapp: 'HRMS14XC2',
      labelIndex: '80',
      style: 'min-width: 150px;'
    }, {
      key: 'dtesnd',
      name: '',
      labelCodapp: 'HRMS14XC2',
      labelIndex: '90',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'dteapph',
      name: '',
      labelCodapp: 'HRMS14XC2',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 150px;',
      dataType: 'date'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRMS14XC2',
      labelIndex: '110',
      style: 'min-width: 200px;'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRMS14XC2',
      labelIndex: '120',
      style: 'min-width: 150px;'
    }, {
      key: 'remark',
      name: '',
      labelCodapp: 'HRMS14XC2',
      labelIndex: '130',
      style: 'min-width: 200px;'
    }
  ]
  let popupStatusEditTableColumns = [
    {
      key: 'codcompap',
      name: '',
      labelCodapp: 'HRMS14XC3',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 100px;',
      inlineType: 'lov',
      lovType: 'codcomp',
      validateRules: 'requiredAllWhenExistAll:codcompap,codposap',
      eventName: 'codcompap'
    }, {
      key: 'codposap',
      name: '',
      labelCodapp: 'HRMS14XC3',
      labelIndex: '110',
      style: 'min-width: 200px;',
      inlineType: 'lov',
      lovType: 'codpos',
      validateRules: 'requiredAllWhenExistAll:codposap,codcompap',
      eventName: 'codposap'
    }, {
      key: 'codempap',
      name: '',
      labelCodapp: 'HRMS14XC3',
      labelIndex: '120',
      class: 'align-center',
      style: 'min-width: 100px;',
      inlineType: 'lov',
      lovType: 'codempid',
      validateRules: 'requiredAnyWhenNotExistAll:codempap,codcompap-codposap',
      eventName: 'codempap'
    }
  ]
  let popupRouteNoTableColumns = [
    {
      key: 'numseq',
      name: '',
      labelCodapp: 'HRMS14XC4',
      labelIndex: '40',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'namtype',
      name: '',
      labelCodapp: 'HRMS14XC4',
      labelIndex: '50',
      style: 'min-width: 150px;'
    }, {
      key: 'codempap',
      name: '',
      labelCodapp: 'HRMS14XC4',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRMS14XC4',
      labelIndex: '70',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codcompap',
      name: '',
      labelCodapp: 'HRMS14XC4',
      labelIndex: '80',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codposap',
      name: '',
      labelCodapp: 'HRMS14XC4',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'num',
      name: '',
      labelCodapp: 'HRMS14XC4',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRMS14XC4',
      labelIndex: '110',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRMS14XC4',
      labelIndex: '120',
      style: 'min-width: 200px;'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRMS14XC4',
      labelIndex: '130',
      style: 'min-width: 150px;'
    }
  ]

  return {
    en: {
      index: indexColumns,
      popupStatusColumns: popupStatusTableColumns,
      popupStatusEditColumns: popupStatusEditTableColumns,
      popupRouteNoColumns: popupRouteNoTableColumns
    },
    th: {
      index: indexColumns,
      popupStatusColumns: popupStatusTableColumns,
      popupStatusEditColumns: popupStatusEditTableColumns,
      popupRouteNoColumns: popupRouteNoTableColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms14x.js